import { LayoutItem } from "types/layouts";

export const layoutEn: LayoutItem = {
    layout: {
        default: [
            "` 1 2 3 4 5 6 7 8 9 0 - = {bksp}",
            "{tab} q w e r t y u i o p [ ] \\",
            "{lock} a s d f g h j k l ; ' {enter}",
            "{shift} z x c v b n m , . / {shift}",
            ".com @ {space}",
        ],
        shift: [
            "~ ! @ # $ % ^ & * ( ) _ + {bksp}",
            "{tab} Q W E R T Y U I O P { } |",
            '{lock} A S D F G H J K L : " {enter}',
            "{shift} Z X C V B N M < > ? {shift}",
            ".com @ {space}",
        ],
    },
};
export const layoutPl: LayoutItem = {
    layout: {
        default: [
            "\u02DB 1 2 3 4 5 6 7 8 9 0 + ' {bksp}",
            "{tab} q w e r t z u i o p \u017C \u015B \u0144",
            "{lock} a s d f g h j k l \u0142 \u0105 \u00F3 {enter}",
            "{shift} < y x c v b n m , . - \u017A \u0119 \u0107 {shift}",
            ".com @ {space}",
        ],
        shift: [
            '\u00B7 ! " # \u00A4 % & / ( ) = ? * {bksp}',
            "{tab} Q W E R T Z U I O P \u017B \u015A \u0143",
            "{lock} A S D F G H J K L \u0141 \u0104 \u00D3 {enter}",
            "{shift} > Y X C V B N M ; : _ \u0179 \u0118 \u0106 {shift}",
            ".com @ {space}",
        ],
    },
};
export const layoutEs: LayoutItem = {
    layout: {
        default: [
            "\u007c 1 2 3 4 5 6 7 8 9 0 ' \u00bf {bksp}",
            "{tab} q w e r t y u i o p \u0301 +",
            "{lock} a s d f g h j k l \u00f1 \u007b \u007d {enter}",
            "{shift} < z x c v b n m , . - {shift}",
            ".com @ {space}",
        ],
        shift: [
            '\u00b0 ! " # $ % & / ( ) = ? \u00a1 {bksp}',
            "{tab} Q W E R T Y U I O P \u0308 *",
            "{lock} A S D F G H J K L \u00d1 \u005b \u005d {enter}",
            "{shift} > Z X C V B N M ; : _ {shift}",
            ".com @ {space}",
        ],
    },
};
